class YouTubeHero {
    constructor(el) {
        this.el = el;
        this.isMobile = window.matchMedia("(max-width: 667px)").matches;
        this.youTubeID = el.dataset.playerId ?? null;
        // Buttons
        this.pauseBtn = document.getElementById("pause-btn");
        this.unMuteBtn = document.getElementById("unmute-btn");

        this.isPlayerReady = false; // Flag to check if player is ready

        this.setupPlayer();
    }

    setupPlayer() {
        if (!this.youTubeID) {
            return;
        }
        // Load the YouTube IFrame Player API code asynchronously
        if (typeof YT == "undefined") {
            const tag = document.createElement("script");
            tag.src = "https://www.youtube.com/iframe_api";
            const firstScriptTag = document.getElementsByTagName("script")[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        }

        window.onYouTubeIframeAPIReady = () => {
            this.onYouTubeIframeAPIReady();
        };
    }

    onYouTubeIframeAPIReady() {
        // Initialize the YouTube Player
        this.player = new YT.Player(this.el.id, {
            height: "390",
            width: "640",
            videoId: this.youTubeID,
            playerVars: {
                playsinline: 1,
                enablejsapi: 1,
                controls: 0,
                autoplay: 1,
                fs: 0,
                loop: 1,
                mute: 1,
                playlist: this.youTubeID,
            },
            events: {
                onReady: this.onPlayerReady.bind(this),
                onStateChange: this.onPlayerStateChange.bind(this),
            },
        });
    }

    onPlayerReady(event) {
        this.isPlayerReady = true;

        const pauseIcon = document.getElementById("pause-icon");
        const playIcon = document.getElementById("play-icon");
        const heroVideoContainer = document.querySelector(".hero-video");
        const featuredImage = document.querySelector(
            "[data-hero-feature-image]",
        );
        const videoCoverImageMobile = document.querySelector(
            "[data-display-mobile]",
        );

        if (featuredImage && this.player) {
            featuredImage.style.visibility = "hidden";
        }

        if (this.isMobile) {
            // Hide video container on load.
            heroVideoContainer.style.display = "none";

            this.pauseBtn.style.display = "block";
            playIcon.classList.add("show");
            pauseIcon.classList.remove("show");

            if (videoCoverImageMobile) {
                videoCoverImageMobile.style.display = "";
                featuredImage.style.display = "none";
            } else {
                featuredImage.style.visibility = "";
            }

            playIcon.addEventListener("click", () => {
                videoCoverImageMobile.style.display = "none";
                heroVideoContainer.style.display = "block";

                // Ensure playVideo is only called after the player is ready
                if (this.isPlayerReady) {
                    this.player.playVideo();
                }
            });
        } else {
            // Play the video directly when not on mobile
            if (this.isPlayerReady) {
                event.target.playVideo();
            }
        }

        // Add event listeners for play and pause buttons
        this.pauseBtn.addEventListener("click", () => this.togglePlayPause());
        this.unMuteBtn.addEventListener("click", () => this.toggleMute());
    }

    onPlayerStateChange(event) {
        console.log("Player state changed:", event.data);

        if (event.data === YT.PlayerState.PLAYING) {
            console.log("Video is playing");
        }
    }

    // Toggle between play and pause
    togglePlayPause() {
        const pauseIcon = document.getElementById("pause-icon");
        const playIcon = document.getElementById("play-icon");

        if (this.player) {
            const currentState = this.player.getPlayerState();

            // If the video is playing, pause it; if it's paused, play it
            if (currentState === YT.PlayerState.PLAYING) {
                this.player.pauseVideo();
                playIcon.classList.add("show");
                pauseIcon.classList.remove("show");
            } else {
                this.player.playVideo();
                playIcon.classList.remove("show");
                pauseIcon.classList.add("show");
            }
        }
    }

    toggleMute() {
        const unMuteIcon = document.getElementById("unmute-icon");
        const muteIcon = document.getElementById("mute-icon");
        if (this.player) {
            if (this.player.isMuted()) {
                this.player.unMute(); // Unmute the video if it's currently muted
                unMuteIcon.style.display = "none";
                muteIcon.style.display = "";
            } else {
                this.player.mute(); // Mute the video if it's not muted
                unMuteIcon.style.display = "";
                muteIcon.style.display = "none";
            }
        }
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const container = document.querySelector("#player");

    if (container) {
        new YouTubeHero(container);
    }
});

export default YouTubeHero;
